/**
 * Props
 * Title
 * Subtitle
 * Position : one of center or left
 * Weight: semibold or light
 * none
 * cardHeader - className
 *      cardHeaderTitle
 *      cardActionCorner - className
 *              iconClass => onclick
 *              anychildren
 * NEED WORK
 */
import React from 'react';
import classNames from 'classnames';
import { colorStyles, VDLColors } from '../../util/colorStyles';

export interface ISmallCardBottomProps {
  // 	An Option to add grey Border line to SmallCardBottom
  applyTopBorderLine?: boolean;
  // Background color to be applied for the bottom Section
  bottomBackgroundColor?: VDLColors;
  // Allow any children to render for Card Bottom
  children?: any;
  // Assign className for Bottom Card
  className?: string;
}

export class SmallCardBottom extends React.Component<ISmallCardBottomProps, any> {
  render() {
    const { className } = this.props;
    const bottomBackgroundColor = this.props.bottomBackgroundColor ? `${colorStyles(this.props.bottomBackgroundColor)} mdf-cardBackground` : '';
    const applyLineBorder = (this.props.applyTopBorderLine && 'mdf-cardLineBorder') || '';

    return (
      <div className={classNames(`small-card-bottom ${bottomBackgroundColor} ${applyLineBorder}`, className)}>
        {this.props.children}
      </div>
    );
  }
}
